import { Error } from '@lmt/unicorn-shared/app/components/common/Error';
import { SubmitButton } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/SubmitButton';
import { RadioButtonGroup } from '@lmt/unicorn-shared/app/components/common/ui-kit/RadioButtonGroup';
import { FormComponentProps } from '@lmt/unicorn-shared/app/components/global-forms/GlobalForms.types';
import {
  AppLanguage,
  getCurrentLanguage,
  useLanguages,
} from '@lmt/unicorn-shared/app/constants/languages';
import { setLanguage } from '@lmt/unicorn-shared/app/helpers/date-helper';
import { useAdvancedForm } from '@lmt/unicorn-shared/app/helpers/form/advanced-form';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { FC, useCallback, useMemo } from 'react';

import styles from '@lmt/unicorn-shared/app/components/global-forms/Content.module.scss';
import { useEventCallback } from '@mui/material';

type Form = {
  language: AppLanguage;
};

export const ChangeLanguage: FC<FormComponentProps> = (props) => {
  const { formId, tryCompleteForm } = props;
  const languages = useLanguages();
  const i18next = useScopedTranslation('users.change_language_popup');
  const form = useAdvancedForm<Form>(
    useEventCallback(async (data: Form) => {
      await tryCompleteForm('changeLanguage', formId, async () => {
        setLanguage(data.language);
      });
    }),
    useMemo(
      () => ({
        language: getCurrentLanguage(),
      }),
      [],
    ),
    {
      shouldFocusError: true,
      criteriaMode: 'all',
    },
  );
  const language = form.watch('language');
  return (
    <form
      className={styles.container}
      style={{ minHeight: '100px', height: 'auto' }}
      onSubmit={form.handleSubmitDefault}
      data-test-id="changeLanguagePopup"
    >
      <div className={styles.dataContainer}>
        <RadioButtonGroup
          required={true}
          options={languages}
          labelField={'label'}
          value={language}
          onSelectedOptionChanged={(lang) => {
            form.setValue('language', lang!.key);
          }}
          valueField={'key'}
        />
      </div>

      <div className={styles.submitContainer}>
        <Error error={form.overallError} />
        <SubmitButton
          submitting={form.formState.isSubmitting}
          className={styles.submit}
          title={i18next.t('save_button')}
        />
      </div>
    </form>
  );
};
